import React, { useRef, useState } from 'react';
import './../../../Styles/RestaurantPage/FoodDescription.css';
import starImg from './../../../assets/Star3.svg';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import greenDot from '../../../assets/greendot.svg';
import redDot from '../../../assets/reddot.svg';
import foodPlaceHolder from '../../../assets/food-img-placeholder.jpg';
import { IoPlayOutline } from 'react-icons/io5';

function FoodDescription() {
    const [isPlaying, setIsPlaying] = useState(false);
    const [activeTab, setActiveTab] = useState(1);
    const videoRef = useRef(null);
    const { t } = useTranslation();

    const handlePlay = (e) => {
        e.stopPropagation();
        if (videoRef.current) {
            videoRef.current.play();
            setIsPlaying(true);
        }
    };

    const selectedItemData = useSelector((state) => {
        return state?.ItemReducer.selecteditemdata;
    });

    const handleTabClick = (tabNumber) => {
        setActiveTab(tabNumber);
    };
    
    return (
        <div>
            <div className='topmenubar-cart'>
                <SideMenuBar></SideMenuBar>
                <div className='topbar-food-desc'>
                    <TopMenuBar></TopMenuBar>
                </div>
            </div>
            <div className='tabs-content-and-carousel-container'>
                <div className='food-description-media-wrapper'>
                    {selectedItemData?.foodImage?.match(/\.(mp4|webm|ogg)$/i) ? (
                        <div className='food-description-video-container1'>
                            <video
                                src={selectedItemData?.foodImage}
                                muted
                                playsInline
                                // eslint-disable-next-line react/no-unknown-property
                                webkit-playsinline='true'
                                preload='metadata'
                                className='food-description-video1'
                                ref={videoRef}
                                onClick={() => {
                                    if (videoRef.current.paused) {
                                        videoRef.current.play();
                                        setIsPlaying(true);
                                    } else {
                                        videoRef.current.pause();
                                        setIsPlaying(false);
                                    }
                                }}
                                onEnded={() => {
                                    videoRef.current.pause();
                                    setIsPlaying(false);
                                }}
                                onError={(e) => {
                                    e.target.poster = foodPlaceHolder;
                                }}
                            />
                            {!isPlaying && (
                                <button onClick={(e) => handlePlay(e)} className='play-btn'>
                                    <IoPlayOutline color='white' fontSize={34} />
                                </button>
                            )}
                        </div>
                    ) : (
                        <img
                            className='food-description-image'
                            src={selectedItemData?.foodImage || foodPlaceHolder}
                            alt='Food img'
                            onError={(e) => {
                                e.target.src = foodPlaceHolder;
                            }}
                        />
                    )}
                </div>
                <div className='svg-and-title'>
                    <div className='svg-icon-classs'>
                        {selectedItemData?.vegetarian !== null && (
                            <img
                                src={
                                    selectedItemData?.vegetarian === true
                                        ? greenDot
                                        : selectedItemData?.vegetarian === false
                                            ? redDot
                                            : ''
                                }
                                alt='dot'
                            />
                        )}
                    </div>
                    <h1 className='food-name'>{selectedItemData?.menuItemName}</h1>
                </div>

                <div className='food-description-container'>
                    {selectedItemData?.menuItemDescription ? (
                        <p
                            className='food-description'
                            dangerouslySetInnerHTML={{
                                __html:
                  selectedItemData?.menuItemDescription.length > 60
                      ? selectedItemData?.menuItemDescription.slice(0, 60) + '...'
                      : selectedItemData?.menuItemDescription,
                            }}
                        ></p>
                    ) : (
                        ''
                    )}
                </div>
                <div className='star-rating-container'>
                    <div className='star-rating-particular-food'>
                        <img className='star-img-food-desc' src={starImg} alt='starPic' />
                        <p className='food-desc-rating-text'>
                            {selectedItemData?.vendorRating &&
              selectedItemData.vendorRating !== 'N/A'
                                ? selectedItemData.vendorRating
                                : 0}
                        </p>
                    </div>
                    <p className='food-desc-reviews'>
                        {selectedItemData?.vendorReview &&
            selectedItemData.vendorReview !== 'N/A'
                            ? selectedItemData.vendorReview
                            : 0}{' '}
                        {t('restaurantpage.reviews')}
                    </p>
                </div>
                <div className='tabs-and-content-container'>
                    <div className='tabs'>
                        <button
                            className={activeTab === 1 ? 'tab-active1' : 'tab1'}
                            onClick={() => handleTabClick(1)}
                        >
                            {t('restaurantpage.description')}
                        </button>
                        <button
                            className={activeTab === 2 ? 'tab-active2' : 'tab2'}
                            onClick={() => handleTabClick(2)}
                        >
                            {t('restaurantpage.ingredients')}
                        </button>
                    </div>
                    <div className='tab-content'>
                        {activeTab === 1 && (
                            <div className='ingrediants-description'>
                                <div className='ingridents-heading'>
                                    {t('restaurantpage.description-title')}
                                </div>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: selectedItemData?.menuItemDescription,
                                    }}
                                ></p>
                            </div>
                        )}
                        {activeTab === 2 && (
                            <div className='ingrediants-description'>
                                <div className='ingridents-heading'>
                                    {t('restaurantpage.ingredients-title')}
                                </div>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: selectedItemData?.menuIngridents,
                                    }}
                                ></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <RightSideBar/>
        </div>
    );
}

export default FoodDescription;
